import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  ArgosSpinnerComponent,
  ArgosAlertModule,
  ArgosSimpleModalComponent,
  ArgosModalModule
} from '@core-argos-angular-artifact/components';
import { FormAlertMessageComponent } from './components/form-alert-message/form-alert-message.component';
import { GreetingComponent } from './components/greeting/greeting.component';
import { LinkComponent } from './components/link/link.component';
import { SurveyComponent } from './components/survey/survey.component';
import { SanitizePipe } from './pipes/sanitize.pipe';
import {
  SanitizePipe as ArgosSanitizePipe,
  CountryPipe as ArgosCountryPipe,
  CountriesService
} from '@core-argos-angular-artifact/common';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    ArgosModalModule,
    ArgosSimpleModalComponent,
    ArgosSanitizePipe,
    ArgosCountryPipe,
    ArgosSpinnerComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    ArgosAlertModule,
    ArgosSanitizePipe,
    ArgosCountryPipe,
    LinkComponent,
    SanitizePipe,
    GreetingComponent,
    FormAlertMessageComponent,
    SurveyComponent,
    ArgosModalModule,
    ArgosSimpleModalComponent,
    ArgosSpinnerComponent
  ],
  declarations: [
    LinkComponent,
    SanitizePipe,
    GreetingComponent,
    SurveyComponent,
    FormAlertMessageComponent
  ],
  providers: [CountriesService]
})
export class SharedModule {}
